import { render, staticRenderFns } from "./ManifestPlanningStep.vue?vue&type=template&id=b2388860&scoped=true&"
import script from "./ManifestPlanningStep.vue?vue&type=script&lang=js&"
export * from "./ManifestPlanningStep.vue?vue&type=script&lang=js&"
import style0 from "./ManifestPlanningStep.vue?vue&type=style&index=0&id=b2388860&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2388860",
  null
  
)

export default component.exports